import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { HexColorInput, HexColorPicker } from 'react-colorful';
import { IoIosArrowRoundBack } from 'react-icons/io';

import { isFunction } from 'shared/lib/utils';

export function ColorPicker({
  className,
  setIsEditingColor,
  color,
  setColor,
  onColorChange,
  onColorPicked,
  presetColors,
  showBackButton,
}) {
  const [didMouseDownColorPicker, setDidMouseDownColorPicker] = useState(false);

  useEffect(() => {
    onColorChange(color);
  }, [color, onColorChange]);

  function onMouseUp(_e) {
    if (!didMouseDownColorPicker) {
      return;
    }

    onColorPicked(color);
    setDidMouseDownColorPicker(false);
  }

  useEffect(() => {
    document.addEventListener('mouseup', onMouseUp);

    return () => {
      document.removeEventListener('mouseup', onMouseUp);
    };
  }, [onMouseUp]);

  return (
    <div className={clsx(['flex gap-2', className])}>
      <div className="flex flex-col gap-1">
        {presetColors.map((presetColor) => (
          <button
            key={presetColor}
            className="h-5 w-5 cursor-pointer rounded sm:h-7 sm:w-7 lg:h-10 lg:w-10"
            style={{ background: presetColor }}
            onClick={(e) => {
              e.preventDefault();
              setColor(presetColor);
              onColorPicked(presetColor);
            }}
          />
        ))}
      </div>

      <div className="flex flex-col gap-2">
        <HexColorPicker
          className="!h-24 !w-24 sm:!h-32 sm:!w-32 lg:!h-48 lg:!w-48"
          color={color}
          onMouseDown={(_e) => setDidMouseDownColorPicker(true)}
          onChange={(color) => setColor(color)}
        />

        <div className="flex w-24 rounded border sm:w-32">
          <span className="px-1">#</span>

          <HexColorInput
            type="text"
            className="inline-block w-full"
            color={color}
            onChange={(color) => {
              setColor(color);
              onColorPicked(color);
            }}
          />
        </div>
      </div>

      {(() => {
        if (!showBackButton) {
          return null;
        }

        if (!isFunction(setIsEditingColor)) {
          return null;
        }

        return (
          <IoIosArrowRoundBack
            size="1.5rem"
            onClick={() => setIsEditingColor(false)}
            className="ml-auto cursor-pointer"
          />
        );
      })()}
    </div>
  );
}

export default ColorPicker;
